import api from './api';
import apiNoHeaders from './apiNoHeaders';
import idbService from './idbService';
import { createClienteModel } from '../utils/clienteUtils';

// idb store name
const storeName = 'clientes';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configPedidos');
const host = configLocal ? JSON.parse(configLocal).host : '';
const apiRequest = environment === 'production' ? api : apiNoHeaders;
const baseURL = environment === 'production' ? `erp?url=${host}` : host;
const idColaborador = configLocal ? JSON.parse(configLocal).idColaborador : '';
const endpoint = 'cliente'
// const sqlCliente = configLocal ? JSON.parse(configLocal).sqlCliente : '';
// const sqlCliente = 6;

export const clienteService = {
  getClientes,
  getClienteFromIndex,
  sendClienteAPI,
  sendClienteByIdAPI,
  getClientesAPI,
  getClienteDetalhesAPI,
  // getClienteEnderecosAPI,
  // getClienteTelefonesAPI,
  // getClienteEmailsAPI,
  getClienteFinanceiroAPI,
  getClienteProdutosVendidosAPI,
  getClienteProdutoVendidoAPI,
  getCliente,
  addCliente,
  addClientes,
  updateCliente,
  deleteCliente,
  compareAndUpdateClientes
};

function getClientes() {
  // Fetch indexedDB Items
  // const itemsIndexedDB = await getIndexedDBClientes();
  // if (itemsIndexedDB.length) return itemsIndexedDB;
  // return getClientesAPI();
  return getIndexedDBClientes();
}

async function sendClienteAPI(cliente) {
  if (!cliente) {
    throw new Error('Cliente não informado');
  }

  if (cliente.id_cliente) {
    throw new Error('Cliente já sincronizado');
  }

  try { 
    const response = await apiRequest.post(`${baseURL}/cliente?Acao=registro`, {
      dados: cliente
    });
    cliente.id_cliente = Number(process.env.NODE_ENV === 'production' ? response.data.result.id_cliente : response.data.id_cliente);
    
    delete cliente.versao_imp;

    await updateCliente(cliente);

    return Promise.resolve(cliente);
  } catch (error) {
    const { response } = error;

    if (response) {
      const { id_cliente, mensagem } = process.env.NODE_ENV === 'production' ? response.data.result : response.data;

      if (mensagem === 'Cliente ja cadastrado!') {
        cliente.id_cliente = +id_cliente;
    
        delete cliente.versao_imp;

        await updateCliente(cliente);

        return Promise.resolve(cliente);
      }
    }

    throw new Error('Ocorreu um erro ao inserir o cliente');
  }
}

async function sendClienteByIdAPI(idClienteInterno) {
  const cliente = await getCliente(idClienteInterno);

  if (!cliente) {
    throw new Error('Cliente não existe');
  }

  if (cliente.id_cliente) {
    throw new Error('Cliente já sincronizado');
  }

  try {
    const clienteInserido = await sendClienteAPI(cliente);
    return Promise.resolve(clienteInserido);
  } catch (error) {
    console.log(error);
    throw new Error('Ocorreu um erro ao inserir o cliente');
  }
}

async function getClientesAPI() {
  const response = await apiRequest.post(`${baseURL}/${endpoint}`, {
    campos: [
      "id_cliente",
      "tipo_pessoa",
      "razao_social",
      "nome_fantasia",
      "cpf_cnpj",
      "rg_ie",
      "contato",
      "telefone",
      "email",
      "endereco",
      "numero_endereco",
      "complemento",
      "ponto_referencia",
      "bairro",
      "cidade",
      "cep",
      "id_colaborador",
      "colaborador",
      "id_tabela_preco",
      "tabela_preco",
      "id_condicao_pagamento",
      "condicao_pagamento",
      "limite_credito"
    ],
    filtros: [
      {
        campo: "id_colaborador",
        criterio: "igual",
        valor: idColaborador
      },
      {
        campo: "status",
        criterio: "igual",
        valor: "A"
      }
    ]
  }, {
    params: {
      Acao: 'lista'
    }
  });
  const clientesApi = environment === 'production' ? response.data.result || [] : response.data || [];
  
  await compareAndUpdateClientes(clientesApi);
  await removeInexistentes(clientesApi);
  // return clientesApi;
  return getIndexedDBClientes();
}

async function getClienteFinanceiroAPI(idCliente) {
  if (!idCliente) {
    throw new Error('idCliente não informado');
  }

  try {
    const response = await apiRequest.post(`${baseURL}/${endpoint}`, {
      campos: [
        'qtde_receber_vencido',
        'total_receber_vencido'
      ]
    }, {
      params: {
        Acao: 'info_financeira',
        id_cliente: idCliente
      }
    });
    const financeiro = environment === 'production' ? response.data.result || [] : response.data || [];
    const updCliente = await getClienteFromIndex('id_cliente', idCliente);
    updCliente.financeiro = {
      Quantidade: financeiro.qtde_receber_vencido,
      Total: financeiro.total_receber_vencido
    };
    await updateCliente(updCliente);
    return updCliente;
  } catch (error) {
    console.log(error);
    throw new Error('Ocorreu um erro ao buscar o financeiro do cliente');
  }
}

async function getClienteDetalhesAPI(idCliente) {
  if (!idCliente) {
    throw new Error('idCliente não informado');
  }

  try {
    const response = await apiRequest.get(`${baseURL}/${endpoint}/${idCliente}`);
    const clienteDetalhes = environment === 'production' ? response.data.result || [] : response.data || [];
    const updCliente = await getClienteFromIndex('id_cliente', idCliente);
    clienteDetalhes.id_interno = updCliente.id_interno;
    clienteDetalhes.financeiro = updCliente.financeiro;
    const parsedCliente = createClienteModel(clienteDetalhes);
    await updateCliente(parsedCliente);
    return parsedCliente;
  } catch (error) {
    console.log(error);
    throw new Error('Ocorreu um erro ao buscar os detalhes do cliente');
  }
}

// function getClienteEnderecosAPI(idCliente) {
//   return apiRequest.get(`${baseURL}/sql/17?:idCliente=${idCliente}`);
// }

// function getClienteTelefonesAPI(idCliente) {
//   return apiRequest.get(`${baseURL}/sql/18?:idCliente=${idCliente}`);
// }

// function getClienteEmailsAPI(idCliente) {
//   return apiRequest.get(`${baseURL}/sql/19?:idCliente=${idCliente}`);
// }

function getClienteProdutosVendidosAPI(idCliente) {
  return apiRequest.get(`${baseURL}/sql/21?:idCliente=${idCliente}`);
}

function getClienteProdutoVendidoAPI(idCliente, idProduto) {
  return apiRequest.get(`${baseURL}/sql/22?:idCliente=${idCliente}&:idProduto=${idProduto}`);
}

function getIndexedDBClientes() {
  return idbService.getAll(storeName);
}

function getCliente(idInterno) {
  return idbService.getById(storeName, idInterno);
}

function getClienteFromIndex(indexName, idCliente) {
  return idbService.getFromIndex(storeName, indexName, idCliente);
}

async function compareAndUpdateClientes(clientes) {
  if (clientes && clientes.length) {
    for (const cliente of clientes) {
      // const savedCliente = await getCliente(cliente.id_interno);
      const savedCliente = await getClienteFromIndex('id_cliente', cliente.id_cliente);
  
      if (!savedCliente) {
        await addCliente(cliente);
      } else {
        cliente.id_interno = savedCliente.id_interno;
        cliente.financeiro = savedCliente.financeiro;
        await updateCliente(cliente);
      }
    }
  } else {
    // Limpa os registros do store clientes
    await idbService.clearStore(storeName);
  }
}

async function removeInexistentes(clientesApi) {
  if (clientesApi && clientesApi.length) {
    const idsClientesApi = clientesApi.map(clienteApi => clienteApi.id_cliente);
    const clientesLocal = await idbService.getAll(storeName, 'id_cliente');
    const clientesInexistentes = clientesLocal.filter(clienteLocal => !idsClientesApi.includes(clienteLocal.id_cliente));
    if (clientesInexistentes && clientesInexistentes.length) {
      for (const cliente of clientesInexistentes) {
        if (cliente.id_cliente) {
          await deleteCliente(cliente.id_interno);
        }
      }
    }
  } else {
    return;
  }
}

function addCliente(cliente) {
  // const parsedCliente = createClienteModel(cliente);
  return idbService.addToStore(storeName, cliente);
}

function addClientes(clientes = []) {
  const parsedClientes = clientes.map(cliente => createClienteModel(cliente));
  return idbService.addMultipleToStore(storeName, parsedClientes);
}

async function updateCliente(cliente) {
  const parsedCliente = createClienteModel(cliente);
  await idbService.updateItem(storeName, parsedCliente);
}

async function deleteCliente(idInterno) {
  await idbService.deleteFromStore(storeName, idInterno);
}